module.exports = __webpack_public_path__ + "img/singletrack-study-library.5b710f8b.png";